import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { DialogActionsEnum, IDialogTrigger } from '../../dialog.data';
import { DialogService } from '../../dialog.service';
import { DIALOG_TYPE } from './loading-dialog.constant';
import { filter, takeUntil } from 'rxjs/operators';

export interface ILoadingDialogData {
  label: string;
}

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingDialogComponent implements OnInit, OnDestroy {
  private _destroyed: Subject<boolean> = new Subject<boolean>();

  dialogType: string;
  loadingTitle: string;
  loadingSpinnerIcon: IIcon;

  constructor(
    private _translateService: TranslateService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _dialogService: DialogService
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.loadingSpinnerIcon = {
      name: 'i2g-loader',
      size: IconSizesEnum.x_large,
    };

    this._dialogService.dialogTriggers$
      .pipe(
        filter((dialogTrigger: IDialogTrigger) => {
          return (
            dialogTrigger.type === this.dialogType &&
            dialogTrigger.action === DialogActionsEnum.open
          );
        }),
        takeUntil(this._destroyed)
      )
      .subscribe((dialogTrigger: IDialogTrigger) => {
        const dialogData: ILoadingDialogData = dialogTrigger.data;

        this.loadingTitle =
          dialogData.label || this._translateService.instant('DIALOG.LOADING');

        this._changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
